/**
 * Returns the current IP address from the Redux store
 * @returns {string} The user's IP address or a default string
 */
export const getUserIp = () => {
  // Access store through window global to avoid circular imports
  const state = window.store?.getState() || {};
  return state.user?.ip || "string";
};

/**
 * Returns the current coordinates from the Redux store
 * @returns {Object} Object containing latitude and longitude
 */
export const getUserCoordinates = () => {
  // Access store through window global to avoid circular imports
  const state = window.store?.getState() || {};
  const coords = state.user?.coordinates || {};
  
  return {
    latitude: String(coords.lat || ""),
    longitude: String(coords.lng || "")
  };
};

/**
 * Returns location data formatted for API payloads
 * @returns {Object} Object containing ip, latitude, and longitude
 */
export const getLocationForPayload = () => {
  const ip = getUserIp();
  const { latitude, longitude } = getUserCoordinates();
  
  return {
    ip,
    latitude,
    longitude
  };
};

export default {
  getUserIp,
  getUserCoordinates,
  getLocationForPayload
}; 